module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Email Preview":"E-Mail Vorschau","From":"Von","To":"An","Subject":"Betreff","open":"Geöffnet","opens":"Geöffnet","click":"Klick","clicks":"Klicks"}}')
  delete Component.options._Ctor
}
